import {
    GetSessionError,
    useGetProxied,
} from '~/backend/connector-api/connector-components';
import { Session } from '~/backend/connector-api/connector-schemas';
import { EnvironmentObjectIds } from '~/engine/data/Environment';
import useImageTranslationTask from '~/hooks/workflows/connector/tasks/useImageTranslationTask';
import { transformAvailableModelsData } from '~/utils/transforms/predictionModelsDataTransforms';
import ImageTranslation from './ImageTranslation';

type ImageTranslationConnectorWorkflowProps = {
    sessionData: Session | undefined;
    environmentObjectIds: EnvironmentObjectIds | undefined;
    isLoadingSession: boolean;
    error: Error | GetSessionError | null;
};

export default function ImageTranslationConnectorWorkflow({
    sessionData,
    environmentObjectIds,
    isLoadingSession,
    error,
}: ImageTranslationConnectorWorkflowProps) {
    const { start: startProcessing, isSubmitting } = useImageTranslationTask({
        studyId:
            environmentObjectIds?.primaryImage?.studyInstanceUID ??
            (sessionData?.payload.context_image.study_instance_uid || ''),
        seriesId:
            environmentObjectIds?.primaryImage?.seriesInstanceUID ??
            (sessionData?.payload.context_image.series_instance_uid || ''),
    });
    const { data: modelsData, isLoading: isLoadingModels } = useGetProxied({
        pathParams: {
            rest: 'translation/list-active-models',
        },
    });

    const {
        data: modelCustomizations = [],
        isLoading: isLoadingCustomizations,
    } = useGetProxied(
        { pathParams: { rest: 'config/translation' } },
        { refetchInterval: 10000 }
    );

    const availableModels = modelsData
        ? transformAvailableModelsData(modelsData)
        : [];

    return (
        <ImageTranslation
            key={'image-translation-modal'}
            availableModels={availableModels}
            modelCustomizations={modelCustomizations}
            onSubmit={startProcessing}
            isLoadingModels={isLoadingModels || isLoadingCustomizations}
            isLoadingSession={isLoadingSession}
            isSubmitting={isSubmitting}
            error={error}
            showPseudonymization={false}
        />
    );
}
